import type { ContestSettings } from '@betterpool/api-types/contests-service';

import formatEarnings from '../domains/game/domains/common/dfs/utils/formatEarnings';

const getFormattedScore = (
  score?: number,
  {
    isWithPrefix = true,
    scoreType,
    withoutScoreMark = 'E',
  }: {
    isWithPrefix?: boolean;
    scoreType?: ContestSettings['scoreType'];
    withoutScoreMark?: string;
  } = {}
) => {
  if (scoreType === 'dollars') {
    return formatEarnings(score);
  }

  if (!score) {
    return withoutScoreMark;
  }

  if (score > 0) {
    return isWithPrefix ? `+${score}` : score;
  }

  return score;
};

export default getFormattedScore;
